module.exports = __webpack_public_path__ + "img/maps_pin_b.17e0dacf.png";